import { AsyncPipe, LowerCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { GroupSelectComponent, GroupSelectOptionComponent } from '@rma/generic/ui/forms/group-select';
import { filter, take } from 'rxjs';
import { BedroomsOptionType, BedroomsOptions } from '../domain/bedroom-options';
import { FindMyAgentStore } from '../orc-find-my-agent/find-my-agent.store';

@Component({
  selector: 'rma-bedrooms',
  imports: [AsyncPipe, GroupSelectComponent, GroupSelectOptionComponent, LowerCasePipe, ReactiveFormsModule, TranslocoModule],
  templateUrl: './bedrooms.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BedroomsComponent {
  protected readonly store = inject(FindMyAgentStore);
  protected readonly control = new FormControl<BedroomsOptionType | null>(null, [Validators.required]);
  protected readonly options = BedroomsOptions;

  constructor() {
    this.control.valueChanges
      .pipe(filter(Boolean), take(1))
      .subscribe((bedrooms) => this.store.patchState({ bedrooms, nextStep: 'whentosell' }));
  }
}
